import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import styled from 'styled-components'
import { accessibilityColors, borderGrey4, themeColor } from '@edulastic/colors'
import {
  MenuTrigger,
  Popover,
  Button,
  Menu,
  MenuItem,
} from 'react-aria-components'
import { IconAddToFolder } from '@edulastic/icons'
import {
  toggleMoveItemsFolderAction,
  toggleRemoveItemsFolderAction,
} from '../../../src/actions/folder'

const AddRemoveTest = ({
  testDetail,
  toggleAddItemModal,
  toggleRemovalModal,
}) => {
  const handleAction = (key) => {
    if (isEmpty(testDetail)) return
    if (key === 'add' && toggleAddItemModal) {
      toggleAddItemModal({ items: [testDetail], isOpen: true })
    }
    if (key === 'remove' && toggleRemovalModal) {
      toggleRemovalModal({ items: [testDetail], isOpen: true })
    }
  }

  return (
    <MenuTrigger>
      <StyledButton
        aria-label={`Add or Remove ${testDetail?.name || ''} from Folder`}
        onClick={(e) => e.stopPropagation()}
      >
        <IconAddToFolder height="18" width="19.13" />
      </StyledButton>
      <StyledPopover>
        <StyledMenu onAction={handleAction}>
          <StyledMenuItem
            id="add"
            data-cy="add-to-folder"
            textValue="Add to Folder"
          >
            Add to Folder
          </StyledMenuItem>
          <StyledMenuItem
            id="remove"
            data-cy="remove-from-folder"
            textValue="Remove from Folder"
          >
            Remove from Folder
          </StyledMenuItem>
        </StyledMenu>
      </StyledPopover>
    </MenuTrigger>
  )
}

const enhance = compose(
  connect(null, {
    toggleRemovalModal: toggleRemoveItemsFolderAction,
    toggleAddItemModal: toggleMoveItemsFolderAction,
  })
)
export default enhance(AddRemoveTest)

const StyledButton = styled(Button)`
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33px;
  min-width: 33px;
  height: 33px;
  max-height: 33px;
  padding: 0;
  border-radius: 50%;
  border: 1.2px solid ${themeColor};
  &:focus {
    outline: 2px solid ${accessibilityColors.theme.blueHover};
    outline-offset: -2px;
  }
`

const StyledPopover = styled(Popover)`
  border: 1px solid ${borderGrey4};
  border-radius: 4px;
  background-color: white;
`

const StyledMenu = styled(Menu)`
  display: flex;
  flex-direction: column;
  outline: none;
`

const StyledMenuItem = styled(MenuItem)`
  padding: 10px 20px;
  background-color: transparent;
  border: none;
  text-align: left;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  outline: none;

  &[data-focused],
  &[data-hovered] {
    background-color: ${accessibilityColors.theme.blueHover};
    color: white;
  }

  &[data-focus-visible] {
    outline: 2px solid ${accessibilityColors.theme.blue};
    outline-offset: -2px;
  }
`
